import { useLang } from "../context/LanguageContext";
import { FadeUp } from "../components/Reveal";

export default function Legal({ doc }) {
  const { t } = useLang();
  const content = t(`legal.${doc}`);
  const paragraphs = Array.isArray(content.body) ? content.body : [content.body];
  return (
    <div className="bg-[#050607] min-h-[70vh]" data-testid={`legal-page-${doc}`}>
      <section className="px-5 md:px-10 pt-40 pb-24 md:pt-48 max-w-3xl mx-auto w-full">
        <FadeUp><div className="eyebrow mb-8">LEGAL</div></FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="font-display text-[30px] sm:text-[44px] text-[#F3F3F0] mb-12">{content.title}</h1>
        </FadeUp>
        <div className="space-y-6">
          {paragraphs.map((p, i) => (
            <FadeUp key={i} delay={0.15 + i * 0.05}>
              <p className="text-[14px] leading-relaxed text-[#999995]">{p}</p>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.3}>
          <p className="mt-14 mono text-[11px] tracking-[0.18em] text-[#666663] uppercase">VEYRONE — 2026</p>
        </FadeUp>
      </section>
    </div>
  );
}
